import React from "react";
import { ButtonHTMLAttributes } from "react";
import { cn } from "../../../util/cn";

interface LoaderButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean;
  minWidth?: number | string;
  className?: string;
  spinnerColorClass?: string;
  children?: React.ReactNode;
}

const LoaderButton: React.FC<LoaderButtonProps> = ({
  loading,
  minWidth,
  className,
  spinnerColorClass,
  children,
  disabled,
  ...rest
}) => {
  const baseClasses = `relative w-full mb-2 rounded px-4 py-2 text-sm font-semibold transition-colors duration-200`;
  const combinedClasses = cn(
    baseClasses,
    className,
    disabled || loading ? "opacity-50 cursor-not-allowed" : ""
  );

  return (
    <button className={combinedClasses} disabled={disabled} style={{ minWidth }} {...rest}>
      {loading ? (
        <div className="flex items-center justify-center w-full">
          <div className={cn("h-5 w-5 animate-spin rounded-full border-2", spinnerColorClass)} />
        </div>
      ) : (
        children
      )}
    </button>
  );
};

export default LoaderButton;
